import request from "@/utils/request.js";
// let path = "/api";
const DevelopmentHistory = {
  /**
   * 查询
   * @param createDate @type String 创建时间
   * @param page @type  Number 页码
   * @param pageSize @type Number 条数
   */
  queryList: async (data) => {
    return await request("post", "/record-center/develop/list", data);
  },
  /**
   * 添加或修改
   * @param id @type String 新增不要 修改必传
   * @param developmentDate @type  String 发展历程时间
   * @param enabled @type Number 是否启用 ENABLE("启用", 1),DISABLE("禁用", 2);
   * @param delStatus @type Number 条数 0未删除 1删除
   * @param createTime @type String 创建时间
   */
  addOrUpDateList: async (data) => {
    return await request("post", "/record-center/develop/add", data);
  },

  /**
   * 删除
   * @param id @type String 删除id
   */
  delList: async (data) => {
    return await request("get", "/record-center/develop/logic-del", data);
  },
};
export default DevelopmentHistory;



// WEBPACK FOOTER //
// ./src/api/developmentHistory.js